import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as changeImpacts from '../../change-impacts'

export const RESOURCE = {
  payload: {
    description: 'Change Impacts that Attain Partners serves',
    dimension: changeImpacts.RESOURCE.payload,
    level: 0,
    name: 'Change Impact',
    partialId: PartialId.Standard.create('change_impact'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
